import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Form, Modal, ModalDialog, Pagination, Row, Spinner } from "react-bootstrap";
import { RootState } from "../../store.ts";
import { connect } from "react-redux";
import Layout from "../../containers/hocs/layout/Layout.tsx";
import Swal from "sweetalert2";
import SkeletonLoader from "../Utils/SkeletonLoader.tsx";
import { Objeto } from "../Navegacion/Profile.tsx";
import { Helmet } from "react-helmet-async";
import {
  ArrowBarLeft,
  ArrowBarRight,
  ArrowRepeat,
  ArrowsCollapseVertical,
  Check2Circle,
  CircleFill,
  Clock,
  Download,
  Eraser,
  ExclamationCircle,
  FiletypePdf,
  GeoFill,
  InfoCircle,
  Search,
  XCircle,
} from "react-bootstrap-icons";
import MenuTraspasos from "../Menus/MenuTraspasos.tsx";
import { BlobProvider } from "@react-pdf/renderer";
import Draggable from "react-draggable";
import { limpiarDataActions } from "../../redux/actions/Configuracion/preferenciasActions.tsx";
import { registrarMantenedorDependenciasActions } from "../../redux/actions/Mantenedores/Dependencias/registrarMantenedorDependenciasActions.tsx";
import { recibeTraspasoActions } from "../../redux/actions/Traspasos/recibeTraspasoActions.tsx";
import { listadoTraspasosRecibidosActions } from "../../redux/actions/Traspasos/listadoTraspasosRecibidosActions.tsx";
import { listadoTraspasosEnviadosActions } from "../../redux/actions/Traspasos/listadoTraspasosEnviadosActions.tsx";
import { obtenerAdjuntosActions } from "../../redux/actions/Traspasos/obtenerAdjuntosActions.tsx";
import DocumentoPDFResumenTraspaso from "./DocumentoPDFResumenTraspaso.tsx";
import { listadoTraspasos } from "./RegistrarTraspasos.tsx";
import { filtroListadoTraspasosEnviadosActions } from "../../redux/actions/Traspasos/filtroListadoTraspasosEnviadosActions.tsx";
import { obtenerEtiquetasAltasActions } from "../../redux/actions/Altas/ImprimirEtiquetas/obtenerEtiquetasAltasActions.tsx";
import { listaAltasRegistradasActions } from "../../redux/actions/Altas/AnularAltas/listaAltasRegistradasActions.tsx";
import { PageSizeSelector } from "../Utils/PageSizeSelector.tsx";
import { TablaGenerica } from "../Utils/TablaGenerica.tsx";
import { BusquedaTabla } from "../Utils/BusquedaTabla.tsx";
import { ListaAltas } from "../Altas/RegistrarAltas.tsx";


/* ===================================================================== */
/* ============================== TIPOS ================================ */
/* ===================================================================== */

interface FechasProps {
  fDesde: string;
  fHasta: string;
}

interface ListaAdjuntos {
  nombre: string;
  contenido: string;
}

interface GeneralProps {
  listadoTraspasosEnviados: listadoTraspasos[];
  filtroListadoTraspasosEnviados: listadoTraspasos[];
  listadoTraspasosRecibidos: listadoTraspasos[];
  listadoTraspasosAdjuntos: ListaAdjuntos[];
  listadoTraspasosEnviadosActions: (fDesde: string, fHasta: string, af_codigo_generico: string, tras_corr: number, establ_corr: number, usuario_crea: number, pas_estado_recibe: number) => Promise<listadoTraspasos[] | null>;
  filtroListadoTraspasosEnviadosActions: (fDesde: string, fHasta: string, af_codigo_generico: string, tras_corr: number, establ_corr: number, usuario_crea: number, pas_estado_recibe: number) => Promise<listadoTraspasos[] | null>;
  listadoTraspasosRecibidosActions: (fDesde: string, fHasta: string, af_codigo_generico: string, tras_corr: number, establ_corr: number, usuario_crea: number, pas_estado_recibe: number, altas_corr: number) => Promise<listadoTraspasos[] | null>;
  registrarMantenedorDependenciasActions: (formModal: Record<string, any>) => Promise<boolean>;
  recibeTraspasoActions: (RecibeTraspaso: Record<string, any>) => Promise<boolean>;
  limpiarDataActions: () => Promise<boolean>;
  obtenerAdjuntosActions: (numTraspaso: number) => Promise<boolean>;
  obtenerEtiquetasAltasActions: (fDesde: string, fHasta: string, establ_corr: number, altasCorr: number, af_codigo_generico: string, dep_corr: number, reimpresion: number) => Promise<boolean>;
  listaAltasRegistradasActions: (fDesde: string, fHasta: string, af_codigo_generico: string, altasCorr: number, idocumento: number, establ_corr: number) => Promise<Array<ListaAltas> | null>;
  token: string | null;
  isDarkMode: boolean;
  objeto: Objeto; // Objeto que obtiene los datos del usuario
}

/* ===================================================================== */
/* ============================ HELPERS ================================ */
/* ===================================================================== */

// Primera letra en mayúscula, resto en minúscula
const PrimeraMayuscula = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

// Mapea el código/usuario creador a su nombre legible
const obtenerNombreUsuario = (usuariO_CREA: any): string => {
  const mapaUsuarios: Record<string, string> = {
    "62511": "Andy Riquelme",
    "18124": "Rodrigo Toledo",
    JCASTILLO: "Jaime Castillo",
    jcastillo: "Jaime Castillo",
    "1770": "Jaime Castillo",
    DROJASP: "Daniel Rojas",
    drojasp: "Daniel Rojas",
    "66098": "Daniel Rojas",
    "1234567": "Felipe Almonte",
    "18667": "Felipe Almonte",
    JVARGAS: "Jonathan Vargas",
    jvargas: "Jonathan Vargas",
    "6405": "Jonathan Vargas",
    GFARIAS: "Gabriela Farias",
    gfarias: "Gabriela Farias",
    "888": "Gabriela Farias",
    "61870": "Elena Navarro",
    "68321": "Ivan Acevedo",
    "67234": "Ignacio Avilés",
    "6601": "Benjamin Bulboa",
    "67404": "Ademir Pindea",
    "21479": "Nelsn Quiroz",
    KREYESD: "Katherine Reyes",
    kreyesd: "Katherine Reyes",
    "66099": "Katherine Reyes",
  };

  return mapaUsuarios[String(usuariO_CREA)] ?? usuariO_CREA;
};

/* ===================================================================== */
/* =========================== COMPONENTE ============================== */
/* ===================================================================== */

const ListadoTraspasos: React.FC<GeneralProps> = ({
  listadoTraspasosEnviadosActions,
  filtroListadoTraspasosEnviadosActions,
  listadoTraspasosRecibidosActions,
  recibeTraspasoActions,
  limpiarDataActions,
  obtenerAdjuntosActions,
  obtenerEtiquetasAltasActions,
  listaAltasRegistradasActions,
  listadoTraspasosEnviados,
  listadoTraspasosRecibidos,
  listadoTraspasosAdjuntos,
  token,
  isDarkMode,
  objeto,
}) => {
  /* =================================================================== */
  /* ====================== ESTADOS GENERALES ========================== */
  /* =================================================================== */
  const [___, setEsCreador] = useState(false);
  const [estadoRecibido, setEstadoRecibido] = useState<number>(0);
  const [estadoEnviado, setEstadoEnviado] = useState<number>(0);
  const [loadingValidar, setLoadingValidar] = useState(false);

  // Columna expandida (vista enviados / recibidos)
  const [expandedColumn, setExpandedColumn] = useState<"recibidos" | "enviados" | null>(null);
  const handleExpandColumn = (column: "recibidos" | "enviados") => {
    setExpandedColumn(expandedColumn === column ? null : column);
  };

  // Contadores totales
  const [contadorEnviados, setContadorEnviados] = useState(0);
  const [contadorRecibidos, setContadorRecibidos] = useState(0);

  /* =================================================================== */
  /* =========================== ENVIADOS ============================== */
  /* =================================================================== */
  const [loadingEnviados, setLoadingEnviados] = useState(false);
  const [errorEnviados, setErrorEnviados] = useState<Partial<FechasProps> & {}>({});
  const [_, setElementoSeleccionado] = useState<string[]>([]);
  const [mostrarModalEnviados, setMostrarModalEnviados] = useState<number | null>(null);

  const [ListaEnviados, setListaEnviados] = useState({
    fDesde: "",
    fHasta: "",
    tras_corr: 0,
    af_codigo_generico: "",
    paS_ESTADO_RECIBE: 0,
  });

  // Paginación enviados
  const [paginaActualEnviados, setPaginaActualEnviados] = useState(1);
  const [PaginacionEnviados, setPaginacionEnviados] = useState({ nPaginacionEnviados: 10 });
  const elementosPorPaginaEnviados = PaginacionEnviados.nPaginacionEnviados;
  const indiceUltimoElementoEnviados = paginaActualEnviados * elementosPorPaginaEnviados;
  const indicePrimerElemento = indiceUltimoElementoEnviados - elementosPorPaginaEnviados;

  const elementosActualesEnviados = useMemo(
    () => listadoTraspasosEnviados.slice(indicePrimerElemento, indiceUltimoElementoEnviados),
    [listadoTraspasosEnviados, indicePrimerElemento, indiceUltimoElementoEnviados]
  );

  const totalPaginasEnviados = Array.isArray(listadoTraspasosEnviados)
    ? Math.ceil(listadoTraspasosEnviados.length / elementosPorPaginaEnviados)
    : 0;

  const paginarEnviados = (numeroPagina: number) => setPaginaActualEnviados(numeroPagina);

  /* =================================================================== */
  /* =========================== RECIBIDOS ============================= */
  /* =================================================================== */
  const [loadingRecibidos, setLoadingRecibidos] = useState(false);
  const [errorRecibidos, setErrorRecibidos] = useState<Partial<FechasProps> & {}>({});
  const [__, setElementoSeleccionado1] = useState<string[]>([]);
  const [mostrarModalRecibidos, setMostrarModalRecibidos] = useState<number | null>(null);
  const [resultadoRecibido, setResultadoRecibido] = useState<listadoTraspasos[]>([]);
  const [mostrarBotonValidar, setMostrarBotonValidar] = useState(false);
  const [ultimaTraspasoSeleccionado, setUltimoTraspasoSeleccionado] = useState<number | null>(null);
  const [mostrarModalSeleccionarTodos, setMostrarModalSeleccionarTodos] = useState(false);

  const [ListaRecibidos, setListaRecibidos] = useState({
    fDesde: "",
    fHasta: "",
    tras_corr: 0,
    af_codigo_generico: "",
    buscador: "",
    paS_ESTADO_RECIBE: 0,
    altaS_CORR: 0
  });

  // Paginación recibidos 
  const [paginaActualRecibidos, setPaginaActualRecibidos] = useState(1);
  const [paginacionRecibidos, setPaginacionRecibidos] = useState({ npaginacionRecibidos: 10 });
  const elementosPorPaginaRecibidos = paginacionRecibidos.npaginacionRecibidos;
  const indiceUltimoElementoRecibidos = paginaActualRecibidos * elementosPorPaginaRecibidos;
  const indicePrimerElementoRecibidos = indiceUltimoElementoRecibidos - elementosPorPaginaRecibidos;

  const elementosActualesRecibidos = useMemo(
    () => listadoTraspasosRecibidos.slice(indicePrimerElementoRecibidos, indiceUltimoElementoRecibidos),
    [listadoTraspasosRecibidos, indicePrimerElementoRecibidos, indiceUltimoElementoRecibidos]
  );

  const totalPaginasRecibidos = Array.isArray(listadoTraspasosRecibidos)
    ? Math.ceil(listadoTraspasosRecibidos.length / elementosPorPaginaRecibidos)
    : 0;

  const paginarRecibidos = (numeroPagina: number) => setPaginaActualRecibidos(numeroPagina);

  /* =================================================================== */
  /* ===================== MODAL VALIDAR / RECHAZAR ==================== */
  /* =================================================================== */
  const [paginaActualValidar, setPaginaActualValidar] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [terminoBusqueda, setTerminoBusqueda] = useState("");
  const [mostrarModalValidar, setMostrarModalValidar] = useState(false);
  const [mostrarModalRechazar, setMostrarModalRechazar] = useState(false);
  const [observacion, setObservacion] = useState({ OBSERVACION_RECHAZO: "" });

  // Filtro por Nº Inventario dentro del modal de validación

  const datosFiltrados = useMemo(() => {
    if (!terminoBusqueda.trim()) {
      return resultadoRecibido;
    }

    const termino = terminoBusqueda.toLowerCase();
    return resultadoRecibido.filter((item) => {
      return (
        item.aF_CODIGO_GENERICO.toString().includes(termino) ||
        item.esP_NOMBRE.toLowerCase().includes(termino)
      );
    });
  }, [resultadoRecibido, terminoBusqueda]);
  //------------- Lógica de Paginación----------------//
  // Totales
  const totalRegistros = datosFiltrados.length;
  const totalPaginasValidar = Math.ceil(totalRegistros / pageSize);

  // Índices
  const indiceInicio = (paginaActualValidar - 1) * pageSize;
  const indiceFin = indiceInicio + pageSize;

  // Datos paginados
  const datosFiltradosPaginados = useMemo(() => {
    return datosFiltrados.slice(indiceInicio, indiceFin);
  }, [datosFiltrados, indiceInicio, indiceFin]);
  //-------------Fin Lógica de Paginación----------------//


  /* =================================================================== */
  /* ===================== EXPORTAR COMPROBANTES ====================== */
  /* =================================================================== */
  const [modalMostrarExportarComprobante, setModalMostrarExportarComprobante] = useState(false);
  const [loadingExportar, setLoadingExportar] = useState<number | null>(null);
  const [traspasoParaExportar, setTraspasoParaExportar] = useState<listadoTraspasos[]>([]);

  /* =================================================================== */
  /* ========================== ADJUNTOS ============================== */
  /* =================================================================== */
  const [PaginacionAdj, setPaginacionAdj] = useState({ nPaginacionAdj: 10 });
  const elementosPorPaginaAdj = PaginacionAdj.nPaginacionAdj;
  const indiceUltimoElementoAdj = elementosPorPaginaAdj;
  const indicePrimerElementoAdj = indiceUltimoElementoAdj - elementosPorPaginaAdj;
  const elementosActualesAdj = useMemo(
    () => listadoTraspasosAdjuntos.slice(indicePrimerElementoAdj, indiceUltimoElementoAdj),
    [listadoTraspasosAdjuntos, indicePrimerElementoAdj, indiceUltimoElementoAdj]
  );
  const [loadingAdjuntos, setLoadingAdjuntos] = useState(false);
  const [adjuntosCargados, setAdjuntosCargados] = useState<number | null>(null);

  /* =================================================================== */
  /* ========================== VALIDACIONES ========================== */
  /* =================================================================== */
  const validateEnviados = () => {
    let tempErrors: Partial<any> & {} = {};

    if (ListaEnviados.fDesde && !ListaEnviados.fHasta) {
      tempErrors.fHasta = "Debe ingresar una fecha de término.";
    }
    if (!ListaEnviados.fDesde && ListaEnviados.fHasta) {
      tempErrors.fDesde = "Debe ingresar una fecha de inicio.";
    }
    if (ListaEnviados.fDesde && ListaEnviados.fHasta) {
      if (ListaEnviados.fDesde > ListaEnviados.fHasta) {
        tempErrors.fDesde = "La fecha de inicio no puede ser mayor a la fecha de término.";
        tempErrors.fHasta = "La fecha de término no puede ser menor a la fecha de inicio.";
      }
    }

    setErrorEnviados(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const validateRecibidos = () => {
    let tempErrors: Partial<any> & {} = {};

    if (ListaRecibidos.fDesde && !ListaRecibidos.fHasta) {
      tempErrors.fHasta = "Debe ingresar una fecha de término.";
    }
    if (!ListaRecibidos.fDesde && ListaRecibidos.fHasta) {
      tempErrors.fDesde = "Debe ingresar una fecha de inicio.";
    }
    if (ListaRecibidos.fDesde && ListaRecibidos.fHasta) {
      if (ListaRecibidos.fDesde > ListaRecibidos.fHasta) {
        tempErrors.fDesde = "La fecha de inicio no puede ser mayor a la fecha de término.";
        tempErrors.fHasta = "La fecha de término no puede ser menor a la fecha de inicio.";
      }
    }

    setErrorRecibidos(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  /* =================================================================== */
  /* =========================== EFFECTS ============================== */
  /* =================================================================== */

  // Actualiza contadores y reinicia la paginación cuando cambian los listados

  useEffect(() => {
    setPaginaActualEnviados(1);
    setPaginaActualRecibidos(1);
    setPaginaActualValidar(1);
    if (listadoTraspasosEnviados.length > contadorEnviados) {
      setContadorEnviados(listadoTraspasosEnviados.length);
    }
    if (listadoTraspasosRecibidos.length > contadorRecibidos) {
      setContadorRecibidos(listadoTraspasosRecibidos.length);
    }
  }, [listadoTraspasosEnviados.length, listadoTraspasosRecibidos.length, terminoBusqueda]);

  // Carga inicial
  useEffect(() => {
    listaAutoEnviados();
    listaAutoRecibidos();
  }, [token]);

  const listaAutoEnviados = async () => {
    if (listadoTraspasosEnviados.length == 0) {
      setLoadingEnviados(true);
      const resultado = await listadoTraspasosEnviadosActions(
        "",
        "",
        "",
        0,
        objeto.Roles[0].codigoEstablecimiento,
        objeto.IdCredencial,
        0
      );
      setLoadingEnviados(false);
      if (!resultado) return;
    }
  };

  const listaAutoRecibidos = async () => {
    if (listadoTraspasosRecibidos.length == 0) {
      setLoadingRecibidos(true);
      let resultado: listadoTraspasos[] | null = [];
      resultado = await listadoTraspasosRecibidosActions(
        "",
        "",
        "",
        0,
        objeto.Roles[0].codigoEstablecimiento,
        objeto.IdCredencial,
        0,
        0
      );

      if (!resultado || resultado.length == 0) {
        setLoadingRecibidos(false);
        setMostrarBotonValidar(false);
      } else {
        const sonTodosDelMismoTraspaso = resultado.every((f) => f.n_TRASPASO === ListaRecibidos.tras_corr);
        setMostrarBotonValidar(sonTodosDelMismoTraspaso);
        setLoadingRecibidos(false);
      }
    }
  };

  /* =================================================================== */
  /* ===================== HANDLERS: CHANGE / LIMPIAR ================= */
  /* =================================================================== */
  const handleChangeEnviados = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    const camposNumericos = ["tras_corr", "establ_corr"];
    const newValue: string | number = camposNumericos.includes(name) ? parseFloat(value) || 0 : value;

    setListaEnviados((prevState) => ({ ...prevState, [name]: newValue }));
    setPaginacionEnviados((prevState) => ({ ...prevState, [name]: newValue }));
    setPaginacionAdj((prevState) => ({ ...prevState, [name]: newValue }));
  };

  const handleChangeRecibidos = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    const camposNumericos = ["tras_corr", "establ_corr", "altaS_CORR"];
    const newValue: string | number = camposNumericos.includes(name) ? parseFloat(value) || 0 : value;

    setListaRecibidos((prevState) => ({ ...prevState, [name]: newValue }));
    setPaginacionRecibidos((prevState) => ({ ...prevState, [name]: newValue }));
    // setObservacion((prevState) => ({ ...prevState, [name]: value }));

    // Al filtrar dentro del modal de validación, volvemos a la primera página
    if (name === "buscador" || name === "npaginacionRecibidos") {
      setPaginaActualRecibidos(1);
    }
  };


  const handleLimpiarEnviados = () => {
    setListaEnviados((prev) => ({
      ...prev,
      fDesde: "",
      fHasta: "",
      tras_corr: 0,
      af_codigo_generico: "",
    }));
  };

  const handleLimpiarRecibidos = () => {
    setListaRecibidos((prev) => ({
      ...prev,
      fDesde: "",
      fHasta: "",
      tras_corr: 0,
      af_codigo_generico: "",
      altaS_CORR: 0,
    }));
  };

  /* =================================================================== */
  /* ===================== HANDLERS: BUSCAR / ACTUALIZAR =============== */
  /* =================================================================== */
  const handleBuscarEnviados = async (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLInputElement>) => {
    e.preventDefault();

    if (!validateEnviados()) {
      setLoadingEnviados(false);
      return;
    }

    const resultado = await listadoTraspasosEnviadosActions(
      ListaEnviados.fDesde,
      ListaEnviados.fHasta,
      ListaEnviados.af_codigo_generico,
      ListaEnviados.tras_corr,
      objeto.Roles[0].codigoEstablecimiento,
      objeto.IdCredencial,
      ListaEnviados.paS_ESTADO_RECIBE
    );

    if (!resultado) {
      Swal.fire({
        icon: "warning",
        title: "Sin Resultados",
        text: "No se encontraron resultados para la consulta realizada.",
        confirmButtonText: "Ok",
        background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
        color: `${isDarkMode ? "#ffffff" : "000000"}`,
        confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
        customClass: { popup: "custom-border" },
      });
      setLoadingEnviados(false);
      return;
    }

    setLoadingEnviados(false);
    paginarEnviados(1);
  };

  const handleBuscarRecibidos = async (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLInputElement>) => {
    e.preventDefault();

    if (!validateRecibidos()) {
      setLoadingRecibidos(false);
      return;
    }

    const resultado: listadoTraspasos[] =
      (await listadoTraspasosRecibidosActions(
        ListaRecibidos.fDesde,
        ListaRecibidos.fHasta,
        ListaRecibidos.af_codigo_generico,
        ListaRecibidos.tras_corr,
        objeto.Roles[0].codigoEstablecimiento,
        objeto.IdCredencial,
        ListaRecibidos.paS_ESTADO_RECIBE,
        ListaRecibidos.altaS_CORR
      )) ?? [];

    setResultadoRecibido(resultado);

    if (resultado.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Sin Resultados",
        text: "No se encontraron resultados para la consulta realizada.",
        confirmButtonText: "Ok",
        background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
        color: `${isDarkMode ? "#ffffff" : "000000"}`,
        confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
        customClass: { popup: "custom-border" },
      });
      setLoadingRecibidos(false);
      setMostrarBotonValidar(false);
      return;
    }

    const sonTodosDelMismoTraspaso = resultado.every(
      (f) => f.n_TRASPASO === ListaRecibidos.tras_corr || f.altaS_CORR === ListaRecibidos.altaS_CORR
    );

    if (sonTodosDelMismoTraspaso) {
      const existeRecibido = resultado.some((elemento) => elemento.paS_ESTADO_RECIBE === 1);
      setMostrarBotonValidar(!existeRecibido);
    } else {
      setMostrarBotonValidar(false);
    }

    setLoadingRecibidos(false);
    paginarRecibidos(1);
  };

  const handleActualizar = async () => {
    limpiarDataActions();
    setListaEnviados((prevState) => ({ ...prevState, paS_ESTADO_RECIBE: 0 }));
    setListaRecibidos((prevState) => ({ ...prevState, paS_ESTADO_RECIBE: 0 }));
    listadoTraspasosEnviadosActions(
      "",
      "",
      ListaEnviados.af_codigo_generico,
      ListaEnviados.tras_corr,
      objeto.Roles[0].codigoEstablecimiento,
      objeto.IdCredencial,
      ListaEnviados.paS_ESTADO_RECIBE
    );
    listadoTraspasosRecibidosActions(
      "",
      "",
      ListaRecibidos.af_codigo_generico,
      ListaRecibidos.tras_corr,
      objeto.Roles[0].codigoEstablecimiento,
      objeto.IdCredencial,
      ListaRecibidos.paS_ESTADO_RECIBE,
      ListaRecibidos.altaS_CORR
    );
  };

  /* =================================================================== */
  /* ===================== HANDLERS: VER / CERRAR MODAL =============== */
  /* =================================================================== */
  const handleVerEnviados = async (index: number, lista: any) => {
    setMostrarModalEnviados(index);
    setElementoSeleccionado((prev) => prev.filter((_, i) => i !== index));

    const esCreadorActual = objeto.Roles[0].codigoEstablecimiento === lista.coD_ESTABL_ORIGEN;
    setEsCreador(esCreadorActual);
    setEstadoEnviado(parseInt(lista.paS_ESTADO_RECIBE));

    const numTraspaso = parseInt(lista.n_TRASPASO);
    if (adjuntosCargados !== numTraspaso) {
      setLoadingAdjuntos(true);
      await obtenerAdjuntosActions(numTraspaso);
      setAdjuntosCargados(numTraspaso);
      setLoadingAdjuntos(false);
    }
  };

  const handleVerRecibidos = async (index: number, lista: any) => {
    setMostrarModalRecibidos(index);
    setElementoSeleccionado1((prev) => prev.filter((_, i) => i !== index));
    setEstadoRecibido(parseInt(lista.paS_ESTADO_RECIBE));

    const numTraspaso = parseInt(lista.n_TRASPASO);
    if (adjuntosCargados !== numTraspaso) {
      setLoadingAdjuntos(true);
      await obtenerAdjuntosActions(numTraspaso);
      setAdjuntosCargados(numTraspaso);
      setLoadingAdjuntos(false);
    }
  };

  const handleCerrarModalEnviados = (index: number) => {
    setElementoSeleccionado((prevSeleccionadas) => prevSeleccionadas.filter((fila) => fila !== index.toString()));
    setMostrarModalEnviados(null);
  };

  const handleCerrarModalRecibidos = (index: number) => {
    setElementoSeleccionado1((prevSeleccionadas) => prevSeleccionadas.filter((fila) => fila !== index.toString()));
    setMostrarModalRecibidos(null);
  };

  /* =================================================================== */
  /* ===================== HANDLERS: VALIDAR / RECHAZAR =============== */
  /* =================================================================== */
  const handleConfirmar = async () => {
    const result = Swal.fire({
      icon: "info",
      title: "Confirmar",
      html: `¿Ha recibido ${resultadoRecibido.length === 1 ? "el bien " : "los <b>" + resultadoRecibido.length + "</b> bienes"} en su establecimiento?`,
      confirmButtonText: "Revisar y confirmar",
      denyButtonText: "Marcar como no recibido",
      showDenyButton: true,
      background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
      color: `${isDarkMode ? "#ffffff" : "000000"}`,
      confirmButtonColor: "#1983b4",
      denyButtonColor: "#dc3545",
      customClass: { popup: "custom-border" },
    });

    if ((await result).isConfirmed) {
      setMostrarModalValidar(true);
    }
    if ((await result).isDenied) {
      setMostrarModalRechazar(true);
    }
  };

  const handleValidarSI = async () => {
    setLoadingValidar(true);

    if (resultadoRecibido.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Sin filas seleccionadas",
        text: "Seleccione al menos una fila antes de confirmar la recepción.",
        confirmButtonText: "Ok",
        background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
        color: `${isDarkMode ? "#ffffff" : "000000"}`,
        confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
        customClass: { popup: "custom-border" },
      });
      return;
    }

    const traspaso = resultadoRecibido.map((lista) => ({
      n_TRASPASO: lista.n_TRASPASO,
      aF_CLAVE: lista.aF_CLAVE,
      deP_CORR_ORIGEN: lista.deP_CORR_ORIGEN,
      deP_CORR: lista.deP_CORR,
      paS_ESTADO_RECIBE: 1,
      paS_NOM_RECIBE: PrimeraMayuscula(objeto.Nombre).trim() + " " + PrimeraMayuscula(objeto.Apellido1).trim(),
      fechA_RECIBE: lista.fechA_RECIBE,
      estabL_CORR_ORIGEN: lista.estabL_CORR_ORIGEN, // Origen
      estabL_CORR: objeto.Roles[0].codigoEstablecimiento, // Destino
      altaS_CORR: lista.altaS_CORR,
      observacion: lista.observacion || "",
    }));

    const resultado = await recibeTraspasoActions(traspaso);

    if (resultado) {
      Swal.fire({
        icon: "success",
        title: "Recepción Confirmada",
        text: "Se han recibido correctamente los bienes en su establecimiento.",
        background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
        color: `${isDarkMode ? "#ffffff" : "000000"}`,
        confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
        customClass: { popup: "custom-border" },
      });
      setMostrarModalValidar(false);
      handleLimpiarRecibidos();
      listadoTraspasosRecibidosActions("", "", "", 0, objeto.Roles[0].codigoEstablecimiento, objeto.IdCredencial, ListaRecibidos.paS_ESTADO_RECIBE, 0);
      obtenerEtiquetasAltasActions("", "", objeto.Roles[0].codigoEstablecimiento, 0, "", 0, 0);
      listaAltasRegistradasActions("", "", "", 0, 0, objeto.Roles[0].codigoEstablecimiento);
      setLoadingValidar(false);
      setMostrarBotonValidar(false);
    } else {
      Swal.fire({
        icon: "error",
        title: ":'(",
        text: "Hubo un problema registrando la recepción. Por favor, intente nuevamente.",
        background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
        color: `${isDarkMode ? "#ffffff" : "000000"}`,
        confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
        customClass: { popup: "custom-border" },
      });
      setLoadingValidar(false);
    }
  };

  const handleValidarNO = async () => {
    setLoadingValidar(true);
    setMostrarModalRechazar(false);

    const traspaso = resultadoRecibido.map((lista) => ({
      n_TRASPASO: lista.n_TRASPASO,
      aF_CLAVE: lista.aF_CLAVE,
      deP_CORR_ORIGEN: lista.deP_CORR_ORIGEN,
      deP_CORR: lista.deP_CORR,
      paS_ESTADO_RECIBE: 2,
      paS_NOM_RECIBE: PrimeraMayuscula(objeto.Nombre).trim() + " " + PrimeraMayuscula(objeto.Apellido1).trim(),
      fechA_RECIBE: lista.fechA_RECIBE,
      estabL_CORR_ORIGEN: lista.estabL_CORR_ORIGEN, // Origen
      estabL_CORR: objeto.Roles[0].codigoEstablecimiento, // Destino
      observacion: observacion.OBSERVACION_RECHAZO,
      altaS_CORR: lista.altaS_CORR,
    }));

    const resultado = await recibeTraspasoActions(traspaso);

    if (resultado) {
      Swal.fire({
        icon: "warning",
        title: "Recepción Rechazada",
        text: `${resultadoRecibido.length > 1 ? "Los activos han" : "El activo ha"} sido marcado como rechazado.`,
        background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
        color: `${isDarkMode ? "#ffffff" : "000000"}`,
        confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
        customClass: { popup: "custom-border" },
      });
      setMostrarModalValidar(false);
      handleLimpiarRecibidos();
      listadoTraspasosRecibidosActions("", "", "", 0, objeto.Roles[0].codigoEstablecimiento, objeto.IdCredencial, ListaEnviados.paS_ESTADO_RECIBE, 0);
      obtenerEtiquetasAltasActions("", "", objeto.Roles[0].codigoEstablecimiento, 0, "", 0, 0);
      listaAltasRegistradasActions("", "", "", 0, 0, objeto.Roles[0].codigoEstablecimiento);
      setLoadingValidar(false);
      setMostrarBotonValidar(false);
    } else {
      Swal.fire({
        icon: "error",
        title: ":'(",
        text: "Hubo un problema al registrar la recepción.",
        background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
        color: `${isDarkMode ? "#ffffff" : "000000"}`,
        confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
        customClass: { popup: "custom-border" },
      });
    }

    if (mostrarModalEnviados) {
      setLoadingEnviados(false);
    } else {
      setLoadingRecibidos(false);
    }
  };

  // Guarda la observación por bien dentro del modal de validación
  const handleObservacion = (aF_CODIGO_GENERICO: string, obs: string) => {
    setResultadoRecibido((prev) =>
      prev.map((item) =>
        item.aF_CODIGO_GENERICO === aF_CODIGO_GENERICO
          ? { ...item, observacion: obs }
          : item
      )
    );
  };

  // Selecciona todas las filas del mismo traspaso (no recibidas)
  const handleSeleccionarTodasLasFilas = () => {
    const traspasoActivo = ultimaTraspasoSeleccionado;

    if (traspasoActivo === null) {
      setMostrarModalSeleccionarTodos(false);
      return;
    }

    const todasLasFilas: string[] = [];
    listadoTraspasosRecibidos.forEach((elemento, index) => {
      if (elemento.paS_ESTADO_RECIBE === 1) return;
      if (elemento.n_TRASPASO !== traspasoActivo) return;
      todasLasFilas.push(index.toString());
    });

    if (todasLasFilas.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Sin filas disponibles",
        text: "No hay filas seleccionables (todas están recibidas).",
        background: isDarkMode ? "#1e1e1e" : "#ffffff",
        color: isDarkMode ? "#ffffff" : "#000000",
        confirmButtonColor: isDarkMode ? "#6c757d" : "#0d6efd",
        customClass: { popup: "custom-border" },
      });
      setMostrarModalSeleccionarTodos(false);
      return;
    }

    setUltimoTraspasoSeleccionado(traspasoActivo);
    setMostrarModalSeleccionarTodos(false);
  };

  /* =================================================================== */
  /* ===================== HANDLERS: ADJUNTOS / EXPORTAR ============== */
  /* =================================================================== */
  const handleDescargarAdjunto = (lista: any) => {
    const contenido = listadoTraspasosAdjuntos?.[lista]?.contenido || lista?.contenido;
    const nombreArchivo = lista?.nombre || "documento";

    if (!contenido) {
      console.warn("Sin contenido en el adjunto");
      return;
    }

    const base64Limpio = contenido.replace(/\s/g, "").trim();

    function detectarTipo(base64: string): string {
      if (base64.startsWith("JVBERi0")) return "pdf";
      if (base64.startsWith("/9j/")) return "jpeg";
      if (base64.startsWith("iVBOR")) return "png";
      if (base64.startsWith("R0lGOD")) return "gif";
      return "png"; // fallback
    }

    const tipo = detectarTipo(base64Limpio);
    const mimeType =
      tipo === "pdf"
        ? "application/pdf"
        : tipo === "docx"
          ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          : tipo === "doc"
            ? "image/jpeg"
            : tipo === "png"
              ? "image/png"
              : tipo === "gif"
                ? "image/gif"
                : "application/octet-stream";

    const byteCharacters = atob(base64Limpio);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([new Uint8Array(byteNumbers)], { type: mimeType });
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${nombreArchivo}.${tipo === "jpeg" ? "jpg" : tipo}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => URL.revokeObjectURL(blobUrl), 3000);
  };

  const handleAbrirModalExportar = async (Lista: listadoTraspasos) => {
    setTraspasoParaExportar([Lista]);
    setLoadingExportar(Lista.n_TRASPASO);

    const resultado = await filtroListadoTraspasosEnviadosActions(
      "",
      "",
      "",
      Lista.n_TRASPASO,
      objeto.Roles[0].codigoEstablecimiento,
      objeto.IdCredencial,
      Lista.paS_ESTADO_RECIBE
    );
    const resultadoLista = resultado ?? [];

    const resultadoOrdenado = [...resultadoLista].sort((a, b) =>
      b.n_TRASPASO.toString().localeCompare(a.n_TRASPASO.toString())
    );
    setTraspasoParaExportar(resultadoOrdenado);

    setTimeout(() => {
      setModalMostrarExportarComprobante(true);
    }, 50);
  };

  const columnas = [
    {
      key: "aF_CODIGO_GENERICO" as keyof listadoTraspasos,
      header: "Nº Inventario",
      style: { width: "10%" },
      render: (value: string) => value || "N/A",
    },
    {
      key: "n_TRASPASO" as keyof listadoTraspasos,
      header: "Nº Traspaso",
      style: { width: "9%" },
      render: (value: number) => value || "N/A",
    },
    {
      key: "altaS_CORR" as keyof listadoTraspasos,
      header: "Alta",
      style: { width: "7%" },
      render: (value: number) => value || "N/A",
    },
    {
      key: "paS_FECHA" as keyof listadoTraspasos,
      header: "Fecha",
      style: { width: "11%" },
      render: (value: string) => value || "N/A",
    },
    {
      key: "esP_NOMBRE" as keyof listadoTraspasos,
      header: "Especie",
      style: { width: "23%" },
      render: (value: string) => value || "N/A",
    },
    {
      key: "observacion" as keyof listadoTraspasos,
      header: "Observación",
      style: { width: "40%" },
      render: (_: string, item: listadoTraspasos) => (
        <Form.Control
          size="sm"
          type="text"
          value={item.observacion || ""}
          onChange={(e) =>
            handleObservacion(item.aF_CODIGO_GENERICO, e.target.value)
          }
          maxLength={200}
          placeholder="Ingrese una observación..."
          data-index={`${item.n_TRASPASO}-${item.aF_CODIGO_GENERICO}`}
        />
      ),
    },
  ];
  return (
    <Layout>
      <Helmet>
        <title>Listado de Traspasos</title>
      </Helmet>
      <MenuTraspasos />

      <div className="table-responsive position-relative z-0 hide-scrollbar">
        <div style={{ maxHeight: "80vh" }}>
          <div className="border-bottom shadow-sm p-2 rounded">
            {/* ===================== CABECERA ===================== */}
            <div className="d-lg-flex d-flex-none justify-content-between">
              <h4 className="text-lg-start text-center fw-semibold border-bottom p-1">Listado de Traspasos</h4>
              <div className="d-flex align-items-center justify-content-end text-warning">
                <p className="fw-bold bg-success text-white px-2 fs-08rem rounded-2">Actualizar Enviados y Recibidos</p>
                <button
                  type="button"
                  onClick={handleActualizar}
                  className="btn btn-success d-flex align-items-center justify-content-center m-1 p-1 rounded-circle"
                  title="Actualizar"
                  aria-label="Actualizar información"
                >
                  <ArrowRepeat aria-hidden="true" width={25} height={25} />
                </button>
              </div>
            </div>

            <Row>

              {/* ====================== SECCIÓN ENVIADOS ===================== */}
              <Col className={`border border-1 rounded  small ${expandedColumn === "enviados" ? "col-12" : ""} ${expandedColumn === "recibidos" ? "d-none" : ""} `}>
                <div className="d-flex justify-content-between pt-2">
                  <h5 className={`p-2 fs-5 border-start border-4 border-primary ${isDarkMode ? "bg-dark text-light" : "bg-light"} rounded fw-semibold`}>
                    Enviados {contadorEnviados > 0 && <span className="badge bg-primary ms-2">{contadorEnviados}</span>}
                  </h5>
                  {expandedColumn ? (
                    <ArrowsCollapseVertical
                      className="cursor-pointer border p-1 rounded hide-icon"
                      aria-hidden="true"
                      width={35}
                      height={35}
                      onClick={() => handleExpandColumn("enviados")}
                    />
                  ) : (
                    <ArrowBarRight
                      className="cursor-pointer border p-1 rounded hide-icon"
                      aria-hidden="true"
                      width={35}
                      height={35}
                      onClick={() => handleExpandColumn("enviados")}
                    />
                  )}
                </div>

                {/* Filtros enviados */}
                <Row className="border rounded p-2 m-2">
                  <Col className={`${expandedColumn === "enviados" ? "col-3" : ""} ${expandedColumn === "recibidos" ? "col-12" : ""}`}>
                    <div className="mb-2 ">
                      <div className="flex-grow-1 mb-2">
                        <label htmlFor="fDesde" className="form-label fw-semibold small">Desde</label>
                        <div className="input-group">
                          <input
                            aria-label="Fecha Desde"
                            type="date"
                            className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""} ${errorEnviados.fDesde ? "is-invalid" : ""}`}
                            name="fDesde"
                            onChange={handleChangeEnviados}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") handleBuscarEnviados(e);
                            }}
                            value={ListaEnviados.fDesde}
                            max={new Date().toLocaleDateString("sv-SE", { timeZone: "America/Santiago" })}
                          />
                        </div>
                        {errorEnviados.fDesde && <div className="invalid-feedback d-block">{errorEnviados.fDesde}</div>}
                      </div>

                      <div className="flex-grow-1">
                        <label htmlFor="fHasta" className="form-label fw-semibold small">Hasta</label>
                        <div className="input-group">
                          <input
                            aria-label="Fecha Hasta"
                            type="date"
                            className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""} ${errorEnviados.fHasta ? "is-invalid" : ""}`}
                            name="fHasta"
                            onChange={handleChangeEnviados}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") handleBuscarEnviados(e);
                            }}
                            value={ListaEnviados.fHasta}
                            max={new Date().toLocaleDateString("sv-SE", { timeZone: "America/Santiago" })}
                          />
                        </div>
                        {errorEnviados.fHasta && <div className="invalid-feedback d-block">{errorEnviados.fHasta}</div>}
                      </div>
                    </div>
                  </Col>

                  <Col className={`${expandedColumn === "enviados" ? "col-3" : ""} ${expandedColumn === "recibidos" ? "col-12" : ""}`}>
                    <div className="mb-1">
                      <label htmlFor="af_codigo_generico" className="form-label fw-semibold small">Nº Inventario</label>
                      <input
                        aria-label="af_codigo_generico"
                        type="text"
                        className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                        name="af_codigo_generico"
                        placeholder="Ej: 1000000008"
                        onChange={handleChangeEnviados}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleBuscarEnviados(e);
                        }}
                        maxLength={12}
                        value={ListaEnviados.af_codigo_generico}
                      />
                    </div>
                    <div className="mb-1">
                      <label htmlFor="tras_corr" className="fw-semibold">Nº Traspaso</label>
                      <input
                        aria-label="tras_corr"
                        type="text"
                        className={`form-select ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                        name="tras_corr"
                        size={10}
                        placeholder="Eje: 1000000008"
                        onChange={handleChangeEnviados}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleBuscarEnviados(e);
                        }}
                        maxLength={12}
                        value={ListaEnviados.tras_corr}
                      />
                    </div>
                  </Col>

                  <Col className={`${expandedColumn === "enviados" ? "col-2" : ""} ${expandedColumn === "recibidos" ? "col-12" : ""}`}>
                    <div className="mb-1">
                      <label className="fw-semibold">Estado</label>
                      <select
                        aria-label="estado"
                        className={`form-select ${isDarkMode ? "bg-dark text-light border-secondary" : ""} `}
                        name="paS_ESTADO_RECIBE"
                        onChange={handleChangeEnviados}
                        value={ListaEnviados.paS_ESTADO_RECIBE}
                      >
                        <option value="">Selecccionar</option>
                        <option value="0">Sin Validación</option>
                        <option value="1">Recibidos</option>
                        <option value="2">Rechazado</option>
                      </select>
                    </div>
                    <div className="d-flex gap-2 mt-4">
                      <div></div>
                      <Button onClick={handleBuscarEnviados} variant={`${isDarkMode ? "secondary" : "primary"}`} className="w-100">
                        {loadingEnviados ? (
                          <>
                            Buscar
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="ms-1" />
                          </>
                        ) : (
                          <>
                            Buscar
                            <Search className="flex-shrink-0 h-5 w-5 ms-1" aria-hidden="true" />
                          </>
                        )}
                      </Button>

                      <Button onClick={handleLimpiarEnviados} variant={`${isDarkMode ? "secondary" : "primary"}`} className="w-100">
                        Limpiar
                        <Eraser className="flex-shrink-0 h-5 w-5 ms-1" aria-hidden="true" />
                      </Button>
                    </div>
                  </Col>
                </Row>

                {/* Tamaño de página enviados */}
                <Row className="g-2 align-items-center flex-column flex-lg-row justify-content-between mb-1">
                  <Col xs={12} lg="auto">
                    {listadoTraspasosEnviados.length > 10 && (
                      <div className="d-flex align-items-center justify-content-center justify-content-lg-start">
                        <label htmlFor="nPaginacion" className="form-label fw-semibold mb-0 me-2">Tamaño de página:</label>
                        <select
                          aria-label="Seleccionar tamaño de página"
                          className={`form-select form-select-sm w-auto ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                          name="nPaginacion"
                          onChange={handleChangeEnviados}
                          value={PaginacionEnviados.nPaginacionEnviados}
                        >
                          {[10, 15, 20, 25, 50, 100].map((val) => (
                            <option key={val} value={val}>{val}</option>
                          ))}
                        </select>
                      </div>
                    )}
                  </Col>
                </Row>

                {/* Tabla enviados */}
                {loadingEnviados ? (
                  <SkeletonLoader rowCount={elementosPorPaginaEnviados} />
                ) : listadoTraspasosEnviados.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className={`table  ${isDarkMode ? "table-dark" : "table-hover table-striped "}`}>
                        <thead className={`sticky-top z-0 ${isDarkMode ? "table-dark" : "text-dark table-light "}`}>
                          <tr>
                            <th scope="col" className="text-nowrap small">Estado</th>
                            <th scope="col" className="text-nowrap small">N° Inventario</th>
                            <th scope="col" className="text-nowrap small">N° Traspaso</th>
                            <th scope="col" className="text-nowrap small">Fecha Traspaso</th>
                            <th scope="col" className="text-nowrap small">Nombre Especie</th>
                            <th scope="col" className="text-nowrap small">Entregado por</th>
                            <th scope="col" className={`small ${expandedColumn === "enviados" ? "" : "d-none"}`}>
                              Ubicación Destino<CircleFill className={"flex-shrink-0 h-5 w-5 ms-1 text-success"} aria-hidden="true" />
                            </th>
                            <th scope="col" className="text-nowrap sticky rounded-top small"><b>Detalles</b></th>
                            <th scope="col" className="text-nowrap sticky rounded-top small"><b>Comprobante</b></th>
                          </tr>
                        </thead>
                        <tbody>
                          {elementosActualesEnviados.map((Lista, index) => {
                            const indexReal = indicePrimerElemento + index;
                            return (
                              <tr key={indexReal}>
                                <td className="text-nowrap small">
                                  {Lista.paS_ESTADO_RECIBE === 0 ? <span className="badge bg-primary w-100 small"> Sin Validación</span>
                                    : Lista.paS_ESTADO_RECIBE === 1 ? <span className="badge bg-success w-100 small">Recibido</span>
                                      : Lista.paS_ESTADO_RECIBE === 2 ? <span className="badge bg-danger w-100 small">Rechazado</span>
                                        : <span>-</span>}
                                </td>
                                <td className="text-nowrap small">{Lista.aF_CODIGO_GENERICO}</td>
                                <td className="text-nowrap small">{Lista.n_TRASPASO}</td>
                                <td className="text-nowrap small">{Lista.paS_FECHA}</td>
                                <td className="text-nowrap small">{Lista.esP_NOMBRE}</td>
                                <td className="text-nowrap small">{obtenerNombreUsuario(Lista.usuariO_CREA)}</td>
                                <td className={`small ${expandedColumn === "enviados" ? "" : "d-none"}`}>{Lista.seR_NOMBRE_DESTINO} {Lista.deP_NOMBRE_DESTINO}</td>
                                <td className="text-nowrap sticky rounded small">
                                  <Button variant="outline-primary" className="fw-semibold small" onClick={() => handleVerEnviados(index, Lista)}>
                                    Ver
                                  </Button>
                                </td>
                                <td>
                                  {loadingExportar === Lista.n_TRASPASO ? (
                                    <Button variant="danger" className="fw-semibold small" disabled>
                                      <Spinner animation="border" size="sm" />
                                    </Button>
                                  ) : (
                                    <Button variant="danger" className="fw-semibold" onClick={() => handleAbrirModalExportar(Lista)}>
                                      <FiletypePdf className="flex-shrink-0" width={20} height={20} aria-hidden="true" />
                                    </Button>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* Paginador enviados */}
                    <div className="paginador-container position-relative z-0">
                      <Pagination className="paginador-scroll ">
                        <Pagination.First onClick={() => paginarEnviados(1)} disabled={paginaActualEnviados === 1} />
                        <Pagination.Prev onClick={() => paginarEnviados(paginaActualEnviados - 1)} disabled={paginaActualEnviados === 1} />
                        {Array.from({ length: totalPaginasEnviados }, (_, i) => (
                          <Pagination.Item key={i + 1} active={i + 1 === paginaActualEnviados} onClick={() => paginarEnviados(i + 1)}>
                            {i + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => paginarEnviados(paginaActualEnviados + 1)} disabled={paginaActualEnviados === totalPaginasEnviados} />
                        <Pagination.Last onClick={() => paginarEnviados(totalPaginasEnviados)} disabled={paginaActualEnviados === totalPaginasEnviados} />
                      </Pagination>
                    </div>
                  </>
                ) : (
                  <p className={`text-center  pt-1 pb-1 mb-1 rounded border-0 fs-09em fw-semibold ${isDarkMode ? "bg-dark text-light border border-secondary" : "bg-light text-muted border"}`}>
                    No hay resultados para mostrar.
                  </p>
                )}
              </Col>


              {/* ===================== SECCIÓN RECIBIDOS ===================== */}
              <Col className={`border border-1 rounded small ${expandedColumn === "recibidos" ? "col-12" : ""} ${expandedColumn === "enviados" ? "d-none" : ""}`}>
                <div className="d-flex justify-content-between pt-2">
                  <h5 className={`p-2 fs-5 border-start border-4 border-success ${isDarkMode ? "bg-dark text-light" : "bg-light"} rounded fw-semibold`}>
                    Recibidos {contadorRecibidos > 0 && <span className="badge bg-success ms-2">{contadorRecibidos}</span>}
                  </h5>
                  {expandedColumn ? (
                    <ArrowsCollapseVertical
                      className="flex-shrink-0 cursor-pointer border p-1 rounded hide-icon"
                      aria-hidden="true"
                      width={35}
                      height={35}
                      onClick={() => handleExpandColumn("recibidos")}
                    />
                  ) : (
                    <ArrowBarLeft
                      className="flex-shrink-0 cursor-pointer border p-1 rounded hide-icon"
                      aria-hidden="true"
                      width={35}
                      height={35}
                      onClick={() => handleExpandColumn("recibidos")}
                    />
                  )}
                </div>

                {/* Filtros recibidos */}
                <Row className="border rounded p-2 m-2">
                  <Col className={`${expandedColumn === "recibidos" ? "col-3" : ""} ${expandedColumn === "enviados" ? "col-12" : ""}`}>
                    <div className="mb-2 ">
                      <div className="flex-grow-1 mb-2">
                        <label htmlFor="fDesde" className="form-label fw-semibold small">Desde</label>
                        <div className="input-group">
                          <input
                            aria-label="Fecha Desde"
                            type="date"
                            className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""} ${errorRecibidos.fDesde ? "is-invalid" : ""}`}
                            name="fDesde"
                            onChange={handleChangeRecibidos}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") handleBuscarRecibidos(e);
                            }}
                            value={ListaRecibidos.fDesde}
                            max={new Date().toLocaleDateString("sv-SE", { timeZone: "America/Santiago" })}
                          />
                        </div>
                        {errorRecibidos.fDesde && <div className="invalid-feedback d-block">{errorRecibidos.fDesde}</div>}
                      </div>

                      <div className="flex-grow-1">
                        <label htmlFor="fHasta" className="form-label fw-semibold small">Hasta</label>
                        <div className="input-group">
                          <input
                            aria-label="Fecha Hasta"
                            type="date"
                            className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""} ${errorRecibidos.fHasta ? "is-invalid" : ""}`}
                            name="fHasta"
                            onChange={handleChangeRecibidos}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") handleBuscarRecibidos(e);
                            }}
                            value={ListaRecibidos.fHasta}
                            max={new Date().toLocaleDateString("sv-SE", { timeZone: "America/Santiago" })}
                          />
                        </div>
                        {errorRecibidos.fHasta && <div className="invalid-feedback d-block">{errorRecibidos.fHasta}</div>}
                      </div>
                    </div>
                  </Col>

                  <Col className={`${expandedColumn === "recibidos" ? "col-3" : ""} ${expandedColumn === "enviados" ? "col-12" : ""}`}>
                    <div className="mb-1">
                      <label htmlFor="af_codigo_generico" className="form-label fw-semibold small">Nº Inventario</label>
                      <input
                        aria-label="af_codigo_generico"
                        type="text"
                        className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                        name="af_codigo_generico"
                        placeholder="Ej: 1000000008"
                        onChange={handleChangeRecibidos}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleBuscarRecibidos(e);
                        }}
                        maxLength={12}
                        value={ListaRecibidos.af_codigo_generico}
                      />
                    </div>
                    <div className="mb-1">
                      <label htmlFor="tras_corr" className="fw-semibold">Nº Traspaso</label>
                      <input
                        aria-label="tras_corr"
                        type="text"
                        className={`form-select ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                        name="tras_corr"
                        size={10}
                        placeholder="Eje: 1000000008"
                        onChange={handleChangeRecibidos}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleBuscarRecibidos(e);
                        }}
                        maxLength={12}
                        value={ListaRecibidos.tras_corr}
                      />
                    </div>

                  </Col>

                  <Col className={`${expandedColumn === "recibidos" ? "col-2" : ""} ${expandedColumn === "enviados" ? "col-12" : ""}`}>
                    <div className="mt-1">
                      <label className="fw-semibold">Estado</label>
                      <select
                        aria-label="estado"
                        className={`form-select ${isDarkMode ? "bg-dark text-light border-secondary" : ""} `}
                        name="paS_ESTADO_RECIBE"
                        onChange={handleChangeRecibidos}
                        value={ListaRecibidos.paS_ESTADO_RECIBE}
                      >
                        <option value="">Selecccionar</option>
                        <option value="0">Sin Validación</option>
                        <option value="1">Recibidos</option>
                        <option value="2">Rechazado</option>
                      </select>
                    </div>
                    {/* <div className="mb-1">
                      <label htmlFor="altaS_CORR" className="form-label fw-semibold small">Nº Alta</label>
                      <input
                        aria-label="altaS_CORR"
                        type="text"
                        className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                        name="altaS_CORR"
                        placeholder="0"
                        onChange={handleChangeRecibidos}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleBuscarRecibidos(e);
                        }}
                        maxLength={12}
                        value={ListaRecibidos.altaS_CORR}
                      />
                    </div> */}
                    <div className="d-flex gap-2 mt-4">
                      <Button onClick={handleBuscarRecibidos} variant={`${isDarkMode ? "secondary" : "primary"}`} className="w-100">
                        {loadingRecibidos ? (
                          <>
                            Buscar
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="ms-1" />
                          </>
                        ) : (
                          <>
                            Buscar
                            <Search className="flex-shrink-0 h-5 w-5 ms-1" aria-hidden="true" />
                          </>
                        )}
                      </Button>

                      <Button onClick={handleLimpiarRecibidos} variant={`${isDarkMode ? "secondary" : "primary"}`} className="w-100">
                        Limpiar
                        <Eraser className="flex-shrink-0 h-5 w-5 ms-1" aria-hidden="true" />
                      </Button>
                    </div>
                  </Col>
                  <p className={` text-center pt-1 pb-1 mb-1 rounded fs-09em fw-semibold ${isDarkMode ? "bg-dark text-light border border-secondary" : "bg-light text-muted border"}`}>
                    Para habilitar la validación, ingrese el <strong>Nº de Traspaso</strong> en el filtro de búsqueda.
                  </p>
                </Row>

                {/* Tamaño de página + botón validar recibidos */}
                <Row className="g-2 align-items-center flex-column flex-lg-row justify-content-between mb-1">
                  <Col className={`${expandedColumn === "recibidos" ? "col-lg-9" : "col-lg-6"}`}>
                    {resultadoRecibido.length > 10 && (
                      <div className="d-flex align-items-center justify-content-center justify-content-lg-start">
                        <label htmlFor="npaginacionRecibidos" className="form-label fw-semibold mb-0 me-2">Tamaño de página:</label>
                        <select
                          aria-label="Seleccionar tamaño de página"
                          className={`form-select form-select-sm w-auto ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                          name="npaginacionRecibidos"
                          onChange={handleChangeRecibidos}
                          value={paginacionRecibidos.npaginacionRecibidos}
                        >
                          {[10, 15, 20, 25, 50, 100].map((val) => (
                            <option key={val} value={val}>{val}</option>
                          ))}
                        </select>
                      </div>
                    )}
                  </Col>
                  <Col className={`${expandedColumn === "recibidos" ? "col-lg-2" : "col-lg-3"}`}>
                    {mostrarBotonValidar === true && (
                      <Button variant="success" className=" mb-2 mx-1 w-100" onClick={handleConfirmar}>
                        Validar
                        <span className="badge bg-light text-muted mx-2">{listadoTraspasosRecibidos.length}</span>
                      </Button>
                    )}
                  </Col>
                </Row>

                {/* Tabla recibidos */}
                {loadingRecibidos ? (
                  <SkeletonLoader rowCount={elementosPorPaginaRecibidos} />
                ) : listadoTraspasosRecibidos.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className={`table  ${isDarkMode ? "table-dark" : "table-hover table-striped "}`}>
                        <thead className={`sticky-top z-0 ${isDarkMode ? "table-dark" : "text-dark table-light "}`}>
                          <tr>
                            <th scope="col" className="text-nowrap small">Estado</th>
                            <th scope="col" className="text-nowrap small">N° Inventario</th>
                            <th scope="col" className="text-nowrap small">N° Traspaso</th>
                            <th scope="col" className="text-nowrap small">N° Alta</th>
                            <th scope="col" className="text-nowrap small">Fecha Traspaso</th>
                            <th scope="col" className="text-nowrap small">Nombre Especie</th>
                            <th scope="col" className="text-nowrap small">Entregado por</th>
                            <th scope="col" className={` ${expandedColumn === "recibidos" ? "" : "d-none"}`}>
                              Ubicación Origen<CircleFill className={"flex-shrink-0 h-5 w-5 ms-1 text-warning"} aria-hidden="true" />
                            </th>
                            <th scope="col" className="text-nowrap sticky rounded-top small">Detalles</th>
                          </tr>
                        </thead>
                        <tbody>
                          {elementosActualesRecibidos.map((Lista, index) => {
                            const indexReal = indicePrimerElementoRecibidos + index;
                            return (
                              <tr key={indexReal}>
                                <td className="text-nowrap small">
                                  {Lista.paS_ESTADO_RECIBE === 0 ? <span className="badge bg-primary w-100 small"> Sin Validación</span>
                                    : Lista.paS_ESTADO_RECIBE === 1 ? <span className="badge bg-success w-100 small">Recibido</span>
                                      : Lista.paS_ESTADO_RECIBE === 2 ? <span className="badge bg-danger w-100 small">Rechazado</span>
                                        : <span>-</span>}
                                </td>
                                <td className="text-nowrap small">{Lista.aF_CODIGO_GENERICO}</td>
                                <td className="text-nowrap small">{Lista.n_TRASPASO}</td>
                                <td className="text-nowrap small">{Lista.altaS_CORR}</td>
                                <td className="text-nowrap small">{Lista.paS_FECHA}</td>
                                <td className="text-nowrap small">{Lista.esP_NOMBRE}</td>
                                <td className="text-nowrap small">{obtenerNombreUsuario(Lista.usuariO_CREA)}</td>
                                <td className={`small ${expandedColumn === "recibidos" ? "" : "d-none"}`}>{Lista.seR_NOMBRE_ORIGEN} {Lista.deP_NOMBRE_ORIGEN}</td>
                                <td className="text-nowrap sticky-col-right-0 rounded small">
                                  <Button variant="outline-primary" className="fw-semibold ps-3 pe-3 small" onClick={() => handleVerRecibidos(index, Lista)}>
                                    Ver
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* Paginador recibidos */}
                    <div className="paginador-container position-relative z-0">
                      <Pagination className="paginador-scroll ">
                        <Pagination.First onClick={() => paginarRecibidos(1)} disabled={paginaActualRecibidos === 1} />
                        <Pagination.Prev onClick={() => paginarRecibidos(paginaActualRecibidos - 1)} disabled={paginaActualRecibidos === 1} />
                        {Array.from({ length: totalPaginasRecibidos }, (_, i) => (
                          <Pagination.Item key={i + 1} active={i + 1 === paginaActualRecibidos} onClick={() => paginarRecibidos(i + 1)}>
                            {i + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => paginarRecibidos(paginaActualRecibidos + 1)} disabled={paginaActualRecibidos === totalPaginasRecibidos} />
                        <Pagination.Last onClick={() => paginarRecibidos(totalPaginasRecibidos)} disabled={paginaActualRecibidos === totalPaginasRecibidos} />
                      </Pagination>
                    </div>
                  </>
                ) : (
                  <p className={`text-center  pt-1 pb-1 mb-1 rounded border-0 fs-09em fw-semibold ${isDarkMode ? "bg-dark text-light border border-secondary" : "bg-light text-muted border"}`}>
                    No hay resultados para mostrar.
                  </p>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>


      {/* ============== MODAL: DETALLE TRASPASO ENVIADO ================== */}
      {elementosActualesEnviados.map((fila, index) => (
        <Modal key={index} show={mostrarModalEnviados === index} onHide={() => handleCerrarModalEnviados(index)} size="xl" centered>
          {/* Estado */}
          {estadoEnviado === 0 ? (
            <div className="text-center py-2 rounded fw-semibold fs-09em bg-warning bg-opacity-10 text-warning border-none">
              <Clock className="me-2 flex-shrink-0" aria-hidden="true" />
              Esperando Validación
            </div>
          ) : estadoEnviado === 1 ? (
            <div className="text-center py-2 rounded fw-semibold fs-09em bg-success bg-opacity-10 text-success border-none">
              <Check2Circle className="me-2 flex-shrink-0" aria-hidden="true" />
              Marcado como recibido
            </div>
          ) : (
            <div className="text-center py-2 rounded fw-semibold fs-09em bg-danger bg-opacity-10 text-danger border-none">
              <XCircle className="me-2 flex-shrink-0" aria-hidden="true" />
              Marcado como rechazado
            </div>
          )}

          <Modal.Header closeButton className={isDarkMode ? "darkModePrincipal" : ""}>
            <Modal.Title className="fw-semibold">Traspaso Enviado</Modal.Title>
          </Modal.Header>

          <Modal.Body className={isDarkMode ? "darkModePrincipal" : ""}>
            <Row className="g-1">
              {/* Información General del Traspaso */}
              <Col lg={6}>
                <div className={`p-1 h-100 ${isDarkMode ? "border-secondary" : ""}`}>
                  <h5 className="fw-semibold mb-3 pb-1 border-bottom">Información del Traspaso</h5>
                  <Row className="g-1">
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">Nº Inventario</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.aF_CODIGO_GENERICO || "Sin Información"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">Nº Traspaso</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.n_TRASPASO || "Sin Información"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">Fecha Traspaso</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.paS_FECHA || "No definida"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">Fecha del Memo</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.paS_FECHA_MEMO || "No definida"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">N° Memo de Referencia</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.paS_MEMO_REF || "Sin Información"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">Codigo Especie</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.esP_CODIGO || "Sin Información"}
                      </div>
                    </Col>
                    <Col md={12}>
                      <label className="fw-semibold small text-muted">Especie</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.esP_NOMBRE || "Sin Información"}
                      </div>
                    </Col>
                    <Col md={12}>
                      <label className="fw-semibold small text-muted">Estado</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.paS_ESTADO_AF || "No definida"}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* Origen y Destino */}
              <Col lg={6}>
                <div className={`p-1 h-100 ${isDarkMode ? "border-secondary" : ""}`}>
                  <h5 className="fw-semibold mb-3 pb-1 border-bottom">Establecimiento</h5>
                  <Row className="g-1">
                    <Col md={12} className="p-3 border border-warning rounded-3 border-opacity-50 ">
                      <div className="mb-2">
                        <label className="fw-semibold small d-flex align-items-center mb-1">
                          <GeoFill className="me-2 text-warning" width={15} height={15} aria-hidden="true" />
                          Origen
                        </label>
                        <div className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                          <p className="fs-07rem  text-start">{fila.establecimientO_ORIGEN || "Sin Información"}</p>
                        </div>
                      </div>
                      <div>
                        <label className="fw-semibold small text-muted">Servicio/Dependencia Origen</label>
                        <div className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                          <p className="fs-07rem  text-start">{fila.seR_NOMBRE_ORIGEN + " " + fila.deP_NOMBRE_ORIGEN || "Sin Información"}</p>
                        </div>
                      </div>
                    </Col>

                    <Col md={12} className="p-3 border border-success rounded-3 border-opacity-50 ">
                      <div className="mb-2">
                        <label className="fw-semibold small d-flex align-items-center mb-1">
                          <GeoFill className="me-2 text-success" width={15} height={15} aria-hidden="true" />
                          Destino
                        </label>
                        <div className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                          <p className="fs-07rem  text-start">{fila.establecimientO_DESTINO || "Sin Información"}</p>
                        </div>
                      </div>
                      <div>
                        <label className="fw-semibold small text-muted">Servicio/Dependencia Destino</label>
                        <div className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                          <p className="fs-07rem  text-start">{fila.seR_NOMBRE_DESTINO + " " + fila.deP_NOMBRE_DESTINO || "Sin Información"}</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* Observaciones */}
              <Col lg={12}>
                <div className={`border rounded-3 p-2 ${isDarkMode ? "border-secondary" : ""}`}>
                  <label className="fw-semibold mb-2">Observaciones</label>
                  <div
                    className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}
                    style={{ whiteSpace: "pre-wrap", minHeight: "80px" }}
                  >
                    {fila.paS_OBS || "Sin observaciones"}
                  </div>
                </div>
              </Col>

              {/* Despacho */}
              <Col lg={6}>
                <div className={`border rounded-3 p-3 ${isDarkMode ? "border-secondary" : ""}`}>
                  <h5 className="fw-semibold mb-3 pb-1 border-bottom">Despacho</h5>
                  <div className="mb-1">
                    <label className="fw-semibold small">Entregado Por</label>
                    <p className="d-flex align-items-center mb-0">
                      {fila.paS_NOM_ENTREGA || "Sin Información"}
                      <Check2Circle className="mx-1 text-success flex-shrink-0" aria-hidden="true" />
                    </p>
                  </div>
                  <div className="mb-1">
                    <label className="fw-semibold small">Recibido Por</label>
                    <p className="d-flex align-items-center mb-0">
                      {fila.paS_NOM_RECIBE === "X" ? (
                        <>
                          Esperando Validación
                          <ExclamationCircle className="mx-1 text-warning flex-shrink-0" aria-hidden="true" />
                        </>
                      ) : fila.paS_NOM_RECIBE ? (
                        <>
                          {fila.paS_NOM_RECIBE}
                          <Check2Circle className="mx-1 text-success flex-shrink-0" aria-hidden="true" />
                        </>
                      ) : (
                        <>
                          Esperando Validación
                          <Clock className="mx-1 text-warning flex-shrink-0" size={14} aria-hidden="true" />
                        </>
                      )}
                    </p>
                  </div>
                  <div>
                    <label className="fw-semibold small">Jefe que Autoriza</label>
                    <p className="d-flex align-items-center mb-0">
                      {fila.paS_NOM_AUTORIZA || "Sin Información"}
                      <Check2Circle className="mx-1 text-success flex-shrink-0 fs-bold" aria-hidden="true" />
                    </p>
                  </div>
                </div>
              </Col>

              {/* Documentos */}
              <Col lg={6}>
                {listadoTraspasosAdjuntos.length > 0 ? (
                  <div className={`border rounded-3 p-3 h-100 ${isDarkMode ? "border-secondary" : ""}`}>
                    <h5 className="fw-semibold mb-3 pb-1 border-bottom">Documentos</h5>
                    {loadingAdjuntos ? (
                      <>
                        Cargando documentos...
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="ms-2" />
                      </>
                    ) : (
                      <div className="table-responsive">
                        <table className={`table table-sm mb-0 ${isDarkMode ? "table-dark" : "table-hover"}`}>
                          <thead className={isDarkMode ? "table-dark" : "table-light"}>
                            <tr>
                              <th scope="col">Nombre</th>
                              <th scope="col" className="text-center" style={{ width: "100px" }}>Descargar</th>
                            </tr>
                          </thead>
                          <tbody>
                            {elementosActualesAdj.map((Lista, idx) => {
                              const indexReal = indicePrimerElementoAdj + idx;
                              return (
                                <tr key={indexReal}>
                                  <td>{Lista.nombre}</td>
                                  <td className="text-center">
                                    <Button size="sm" variant="outline-danger" onClick={() => handleDescargarAdjunto(Lista)}>
                                      <Download className="h-4 w-4" aria-hidden="true" />
                                    </Button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                ) : (
                  <p className={`text-center  pt-1 pb-1 mb-1 rounded border-0 fs-09em fw-semibold ${isDarkMode ? "bg-dark text-light border border-secondary" : "bg-light text-muted border"}`}>
                    Sin documentos adjuntos
                  </p>
                )}
              </Col>

              {/* Motivo Rechazo */}
              {estadoEnviado === 2 && (
                <Col lg={12}>
                  <div className={`border-danger bg-danger opacity-75 rounded-3 p-2 ${isDarkMode ? "border-secondary" : ""}`}>
                    <label className="fw-semibold mb-2 text-white">Motivo Rechazo</label>
                    <div
                      className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}
                      style={{ whiteSpace: "pre-wrap", minHeight: "80px" }}
                    >
                      {observacion.OBSERVACION_RECHAZO || "Sin observaciones"}
                    </div>
                  </div>
                </Col>
              )}
            </Row>
          </Modal.Body>
        </Modal>
      ))}

      {/* ============= MODAL: DETALLE TRASPASO RECIBIDO ================= */}
      {elementosActualesRecibidos.map((fila, index) => (
        <Modal key={index} show={mostrarModalRecibidos === index} onHide={() => handleCerrarModalRecibidos(index)} size="xl" centered>
          {/* Estado */}
          {estadoRecibido === 0 ? (
            <div className="text-center py-2 rounded fw-semibold fs-09em bg-warning bg-opacity-10 text-warning border-none">
              <Clock className="me-2 flex-shrink-0" aria-hidden="true" />
              Validación Pediente
            </div>
          ) : estadoRecibido === 1 ? (
            <div className="text-center py-2 rounded fw-semibold fs-09em bg-success bg-opacity-10 text-success border-none">
              <Check2Circle className="me-2 flex-shrink-0" aria-hidden="true" />
              Marcado como recibido
            </div>
          ) : (
            <div className="text-center py-2 rounded fw-semibold fs-09em bg-danger bg-opacity-10 text-danger border-none">
              <XCircle className="me-2 flex-shrink-0" aria-hidden="true" />
              Marcado como rechazado
            </div>
          )}

          <Modal.Header closeButton className={isDarkMode ? "darkModePrincipal" : ""}>
            <Modal.Title className="fw-semibold">Traspaso Recibido</Modal.Title>
          </Modal.Header>

          <Modal.Body className={isDarkMode ? "darkModePrincipal" : ""}>
            <Row className="g-1">
              {/* Información General del Traspaso */}
              <Col lg={6}>
                <div className={`p-1 h-100 ${isDarkMode ? "border-secondary" : ""}`}>
                  <h5 className="fw-semibold mb-3 pb-1 border-bottom">Información del Traspaso</h5>
                  <Row className="g-1">
                    <Col md={6}>
                      <label className="fw-semibold small text-muted mb-1 ">Nº Inventario</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.aF_CODIGO_GENERICO || "Sin Información"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">Nº Traspaso</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.n_TRASPASO || "Sin Información"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">Fecha Traspaso</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.paS_FECHA || "No definida"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">Fecha del Memo</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.paS_FECHA_MEMO || "No definida"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">N° Memo de Referencia</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.paS_MEMO_REF || "Sin Información"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">Codigo Especie</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.esP_CODIGO || "Sin Información"}
                      </div>
                    </Col>
                    <Col md={6}>
                      <label className="fw-semibold small text-muted">Estado</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.paS_ESTADO_AF || "No definida"}
                      </div>
                    </Col>
                    <Col md={12}>
                      <label className="fw-semibold small text-muted">Especie</label>
                      <div className={`rounded border px-3 py-1 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                        {fila.esP_NOMBRE || "Sin Información"}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* Origen y Destino */}
              <Col lg={6}>
                <div className={`p-1 h-100 ${isDarkMode ? "border-secondary" : ""}`}>
                  <h5 className="fw-semibold mb-3 pb-1 border-bottom ">Establecimiento</h5>
                  <Row className="g-1">
                    <Col md={12} className="p-2 border border-warning rounded-3 border-opacity-50 ">
                      <div className="mb-2">
                        <label className="fw-semibold  d-flex align-items-center mb-1">
                          <GeoFill className="me-2 text-warning" width={15} height={15} aria-hidden="true" />
                          Origen
                        </label>
                        <div className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                          <p className="fs-07rem  text-start">{fila.establecimientO_ORIGEN || "Sin Información"}</p>
                        </div>
                      </div>
                      <div>
                        <label className="fw-semibold small text-muted">Servicio/Dependencia Origen</label>
                        <div className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                          <p className="fs-07rem  text-start">{fila.seR_NOMBRE_ORIGEN + " " + fila.deP_NOMBRE_ORIGEN || "Sin Información"}</p>
                        </div>
                      </div>
                    </Col>
                    <Col md={12} className="p-2 border rounded-3 border-success border-opacity-50 ">
                      <div className="mb-2">
                        <label className="fw-semibold  d-flex align-items-center mb-1">
                          <GeoFill className="me-2 text-success" width={15} height={15} aria-hidden="true" />
                          Destino
                        </label>
                        <div className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                          <p className="fs-07rem  text-start">{fila.establecimientO_DESTINO || "Sin Información"}</p>
                        </div>
                      </div>
                      <div>
                        <label className="fw-semibold small text-muted">Servicio/Dependencia Destino</label>
                        <div className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}>
                          <p className="fs-07rem  text-start">{fila.seR_NOMBRE_DESTINO + " " + fila.deP_NOMBRE_DESTINO || "Sin Información"}</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* Observaciones */}
              <Col lg={12}>
                <div className={`border rounded-3 p-2 ${isDarkMode ? "border-secondary" : ""}`}>
                  <label className="fw-semibold mb-2">Observaciones</label>
                  <div
                    className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}
                    style={{ whiteSpace: "pre-wrap", minHeight: "80px" }}
                  >
                    {fila.paS_OBS || "Sin observaciones"}
                  </div>
                </div>
              </Col>

              {/* Recepción */}
              <Col lg={6}>
                <div className={`border rounded-3 p-3 ${isDarkMode ? "border-secondary" : ""}`}>
                  <h5 className="fw-semibold mb-3 pb-1 border-bottom">Recepción</h5>
                  <div className="mb-1">
                    <label className="fw-semibold small">Entregado Por</label>
                    <p className="d-flex align-items-center mb-0">
                      {fila.paS_NOM_ENTREGA || "Sin Información"}
                      <Check2Circle className="mx-1 text-success flex-shrink-0" aria-hidden="true" />
                    </p>
                  </div>
                  <div className="mb-1">
                    <label className="fw-semibold small">Recibido Por</label>
                    <p className="d-flex align-items-center mb-0">
                      {objeto?.Nombre && PrimeraMayuscula(objeto.Nombre)}{" "}{objeto?.Apellido1 && PrimeraMayuscula(objeto.Apellido1)}
                      <Check2Circle className="mx-1 text-success flex-shrink-0" aria-hidden="true" />
                    </p>
                  </div>
                  <div>
                    <label className="fw-semibold small">Jefe que Autoriza</label>
                    <p className="d-flex align-items-center mb-0">
                      {fila.paS_NOM_AUTORIZA || "Sin Información"}
                      <Check2Circle className="mx-1 text-success flex-shrink-0 fs-bold" aria-hidden="true" />
                    </p>
                  </div>
                </div>
              </Col>

              {/* Documentos */}
              <Col lg={6}>
                {listadoTraspasosAdjuntos.length > 0 ? (
                  <div className={`border rounded-3 p-3 h-100 ${isDarkMode ? "border-secondary" : ""}`}>
                    <h5 className="fw-semibold mb-3 pb-1 border-bottom">Documentos</h5>
                    {loadingAdjuntos ? (
                      <>
                        Cargando documentos...
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="ms-2" />
                      </>
                    ) : (
                      <div className="table-responsive">
                        <table className={`table table-sm mb-0 ${isDarkMode ? "table-dark" : "table-hover"}`}>
                          <thead className={isDarkMode ? "table-dark" : "table-light"}>
                            <tr>
                              <th scope="col">Nombre</th>
                              <th scope="col" className="text-center" style={{ width: "100px" }}>Descargar</th>
                            </tr>
                          </thead>
                          <tbody>
                            {elementosActualesAdj.map((Lista, idx) => {
                              const indexReal = indicePrimerElementoAdj + idx;
                              return (
                                <tr key={indexReal}>
                                  <td>{Lista.nombre}</td>
                                  <td className="text-center">
                                    <Button size="sm" variant="outline-danger" onClick={() => handleDescargarAdjunto(Lista)}>
                                      <Download className="h-4 w-4" aria-hidden="true" />
                                    </Button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                ) : (
                  <p className={`text-center  pt-1 pb-1 mb-1 rounded border-0 fs-09em fw-semibold ${isDarkMode ? "bg-dark text-light border border-secondary" : "bg-light text-muted border"}`}>
                    Sin documentos adjuntos
                  </p>
                )}
              </Col>

              {/* Detalles recibido */}
              {estadoRecibido === 1 && (
                <Col lg={12}>
                  <div className={`border-danger bg-success opacity-75 rounded-3 p-2 ${isDarkMode ? "border-secondary" : ""}`}>
                    <label className="fw-semibold mb-2 text-white">Detalles del bien recibido</label>
                    <div
                      className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}
                      style={{ whiteSpace: "pre-wrap", minHeight: "80px" }}
                    >
                      {fila.observacion || "Sin observaciones"}
                    </div>
                  </div>
                </Col>
              )}
              {/* Motivo Rechazo */}
              {estadoRecibido === 2 && (
                <Col lg={12}>
                  <div className={`border-danger bg-danger opacity-75 rounded-3 p-2 ${isDarkMode ? "border-secondary" : ""}`}>
                    <label className="fw-semibold mb-2 text-white">Motivo Rechazo</label>
                    <div
                      className={`rounded border px-3 py-2 ${isDarkMode ? "bg-dark border-secondary text-light" : "bg-light border-muted text-dark"}`}
                      style={{ whiteSpace: "pre-wrap", minHeight: "80px" }}
                    >
                      {listadoTraspasosRecibidos[0].paS_OBS_RECEPCION_GENERAL || "Sin observaciones"}
                    </div>
                  </div>
                </Col>
              )}
            </Row>
          </Modal.Body>
        </Modal>
      ))}

      {/* ====== MODAL: VALIDAR BIENES (ingreso de observaciones) ======== */}
      <Modal
        show={mostrarModalValidar}
        onHide={() => setMostrarModalValidar(false)}
        centered
        dialogClassName="swal-like-modal"
        animation={false}
        size="xl"
      >
        <Modal.Body className={isDarkMode ? "darkModePrincipal" : ""}>
          <div className="d-flex align-items-center justify-content-center m-4">
            <InfoCircle className="text-info opacity-50 me-2 small fw-normal fw-light" size={80} aria-hidden="true" />
          </div>
          <h3 className="text-center mb-3 fw-semibold">Validar Recepción</h3>
          <p className="text-center py-2 mb-1 rounded fw-semibold fs-09em bg-opacity-10 text-muted border-none">
            Confirme la recepción de {resultadoRecibido.length === 1 ? "el bien" : <span> los <b>{resultadoRecibido.length}</b>  bienes</span>} en su establecimiento.
          </p>

          <div className="d-flex justify-content-center m-2">
            {loadingValidar ? (
              <div className="text-center py-4">
                <Spinner
                  animation="border"
                  variant="primary"
                  role="status"
                  style={{ width: "2.5rem", height: "2.5rem" }}
                />
                <div className="mt-3 fw-semibold">
                  Procesando solicitud...
                </div>
                <small className="text-muted">
                  Espere un momento mientras registramos la recepción.
                </small>
              </div>
            ) : (
              <div className="d-flex gap-2 w-100">
                <Button
                  variant="success"
                  className="flex-fill py-2 fw-semibold"
                  onClick={handleValidarSI}
                >
                  <i className="bi bi-check-circle me-2"></i>
                  Confirmar recepción
                </Button>

                <Button
                  variant="danger"
                  className="flex-fill py-2 fw-semibold"
                  onClick={() => setMostrarModalRechazar(true)}
                >
                  <i className="bi bi-x-circle me-2"></i>
                  Rechazar recepción
                </Button>
              </div>
            )}
          </div>

          {/* Filtro Nº Inventario dentro del modal */}
          <Row className={`rounded border p-3 mx-2 mb-3 ${isDarkMode ? "border-secondary" : ""}`}>

            <Col xs={12} lg="auto" className="flex-grow-1 mb-lg-3 mb-1">
              <div className={`w-100 rounded p-3 mb-4 small ${isDarkMode
                ? "bg-dark border border-secondary text-light"
                : "bg-light border text-muted"
                }`}
              >
                <InfoCircle className="flex-shrink-0" width={15} height={15} aria-hidden="true" />
                <i className="bi bi-info-circle-fill me-2 text-primary"></i>
                Si durante la recepción identifica alguna
                situación relevante en uno o más bienes, registre una observación para
                dejar constancia del estado en que fueron recibidos.
              </div>
              <label className="fw-semibold">
                Filtrar por Nº Inventario o Especie
              </label>

              <BusquedaTabla
                value={terminoBusqueda}
                onChange={setTerminoBusqueda}
                isDarkMode={isDarkMode}
                placeholder="Eje: 1000013983 / Silla"
              />
            </Col>
            <PageSizeSelector
              pageSize={pageSize}
              total={resultadoRecibido.length}
              totalFiltrados={datosFiltradosPaginados.length}
              onChange={(size) => setPageSize(size)}
              isDarkMode={isDarkMode}
            />

          </Row>

          {/* Tabla */}
          {loadingValidar ? (
            <SkeletonLoader rowCount={10} />
          ) : (
            <TablaGenerica<listadoTraspasos>
              data={datosFiltradosPaginados}
              columns={columnas}
              isDarkMode={isDarkMode}
            />
          )}

          {/* Paginador */}
          {totalPaginasValidar > 1 && (
            <div className="mt-3 paginador-scroll">
              <ul className="pagination pagination-sm justify-content-center">
                <li className={`page-item ${paginaActualValidar === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setPaginaActualValidar(1)}
                  >
                    Primera
                  </button>
                </li>
                <li className={`page-item ${paginaActualValidar === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setPaginaActualValidar(paginaActualValidar - 1)}
                  >
                    Anterior
                  </button>
                </li>

                {Array.from({ length: Math.min(20, totalPaginasValidar) }, (_, i) => {
                  let pageNum;
                  if (totalPaginasValidar <= 20) {
                    pageNum = i + 1;
                  } else if (paginaActualValidar <= 3) {
                    pageNum = i + 1;
                  } else if (paginaActualValidar >= totalPaginasValidar - 2) {
                    pageNum = totalPaginasValidar - 19 + i;
                  } else {
                    pageNum = paginaActualValidar - 2 + i;
                  }

                  return (
                    <li
                      key={pageNum}
                      className={`page-item ${paginaActualValidar === pageNum ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setPaginaActualValidar(pageNum)}
                      >
                        {pageNum}
                      </button>
                    </li>
                  );
                })}

                <li className={`page-item ${paginaActualValidar === totalPaginasValidar ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setPaginaActualValidar(paginaActualValidar + 1)}
                  >
                    Siguiente
                  </button>
                </li>
                <li className={`page-item ${paginaActualValidar === totalPaginasValidar ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setPaginaActualValidar(totalPaginasValidar)}
                  >
                    Última
                  </button>
                </li>
              </ul>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ============= MODAL: MOTIVO DEL RECHAZO (observación) ========== */}
      <Modal show={mostrarModalRechazar} onHide={() => setMostrarModalRechazar(false)} size="lg" centered>
        <Modal.Header closeButton className="bg-danger text-white bg-opacity-75 border-danger">
          <Modal.Title className="fw-semibold">Motivo del Rechazo</Modal.Title>
        </Modal.Header>
        <Modal.Body className={isDarkMode ? "darkModePrincipal" : ""}>
          <Row className="g-1">
            <div className={`p-1 h-100 ${isDarkMode ? "border-secondary" : ""}`}>
              <Col lg={12}>
                <div className={`border rounded-3 p-2 ${isDarkMode ? "border-secondary" : ""}`}>
                  <label className="fw-semibold mb-2">Observaciones *</label>
                  <textarea
                    className={`form-control ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                    rows={4}
                    placeholder="Describa el motivo del rechazo..."
                    value={observacion.OBSERVACION_RECHAZO}
                    onChange={(e) => setObservacion({ OBSERVACION_RECHAZO: e.target.value })}
                  />
                </div>
              </Col>
            </div>
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button variant="secondary" onClick={() => setMostrarModalRechazar(false)}>Cancelar</Button>
            <Button variant="danger" onClick={handleValidarNO} disabled={!observacion.OBSERVACION_RECHAZO.trim()}>
              Confirmar Rechazo
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* =============== MODAL: EXPORTAR (PDF arrastrable) ============== */}
      <Modal
        show={modalMostrarExportarComprobante}
        onHide={() => setModalMostrarExportarComprobante(false)}
        size="xl"
        centered={false}
        animation={false}
        dialogAs={(props) => (
          <Draggable handle=".modal-header" cancel=".modal-body">
            <ModalDialog {...props} />
          </Draggable>
        )}
      >
        <Modal.Header className={`${isDarkMode ? "darkModePrincipal" : ""}`} closeButton style={{ cursor: "move", userSelect: "none" }}>
          <Modal.Title className="fw-semibold">Exportar</Modal.Title>
        </Modal.Header>
        <Modal.Body className={` ${isDarkMode ? "darkModePrincipal" : ""}`}>
          <BlobProvider document={<DocumentoPDFResumenTraspaso listaSalidaTraspasos={traspasoParaExportar} />}>
            {({ url, loading }) => {
              useEffect(() => {
                if (!loading) setLoadingExportar(null);
              }, [loading]);

              return loading ? (
                <p>Generando vista previa...</p>
              ) : (
                <iframe src={url ?? ""} title="Vista Previa del PDF" style={{ width: "100%", height: "900px", border: "none" }} />
              );
            }}
          </BlobProvider>
        </Modal.Body>
      </Modal>

      {/* ============== MODAL: SELECCIONAR TODOS (confirmación) ========= */}
      <Modal
        show={mostrarModalSeleccionarTodos}
        onHide={() => setMostrarModalSeleccionarTodos(false)}
        centered
        dialogClassName="swal-like-modal"
        animation={false}
      >
        <Modal.Body className={isDarkMode ? "darkModePrincipal" : ""}>
          <div className="d-flex align-items-center justify-content-center m-4">
            <InfoCircle className="text-info opacity-50 me-2 small fw-normal" size={80} aria-hidden="true" />
          </div>
          <h3 className="text-center mb-3 fw-semibold">Seleccionar Todos</h3>
          <p className="text-center py-2 mb-1 rounded fw-semibold fs-09em bg-opacity-10 text-muted border-none">
            ¿Desea selecccionar todos los bienes correspondientes a este traspaso?
          </p>
          <div className="d-flex gap-2 w-50 justify-content-center mx-auto p-2">
            <Button variant="primary" className="w-100" onClick={handleSeleccionarTodasLasFilas}>Si</Button>
            <Button variant="secondary" className="w-100" onClick={() => setMostrarModalSeleccionarTodos(false)}>No</Button>
          </div>
        </Modal.Body>
      </Modal>
    </Layout >
  );
};

/* ===================================================================== */
/* ========================= REDUX CONNECT ============================= */
/* ===================================================================== */

const mapStateToProps = (state: RootState) => ({
  listadoTraspasosEnviados: state.listadoTraspasosEnviadosReducers.listadoTraspasosEnviados || [],
  filtroListadoTraspasosEnviados: state.filtroListadoTraspasosEnviadosReducers.filtroListadoTraspasosEnviados || [],
  listadoTraspasosRecibidos: state.listadoTraspasosRecibidosReducers.listadoTraspasosRecibidos || [],
  listadoTraspasosAdjuntos: state.listadoTraspasosAdjuntosReducers.listadoTraspasosAdjuntos || [],
  token: state.loginReducer.token || null,
  isDarkMode: state.darkModeReducer.isDarkMode || false,
  comboServicio: state.comboServicioReducer.comboServicio || [],
  objeto: state.validaApiLoginReducers,
});

export default connect(mapStateToProps, {
  listadoTraspasosEnviadosActions,
  filtroListadoTraspasosEnviadosActions,
  listadoTraspasosRecibidosActions,
  registrarMantenedorDependenciasActions,
  recibeTraspasoActions,
  limpiarDataActions,
  obtenerAdjuntosActions,
  obtenerEtiquetasAltasActions,
  listaAltasRegistradasActions,
})(ListadoTraspasos);